import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M120-80v-740h125v-60h65v60h340v-60h65v60h125v320h-60v-70H180v430h320v60H120Zm60-550h600v-130H180v130Zm0 0v-130 130ZM560-80v-123l263-262 122 122L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z"
  })
}), "EditCalendar");